/**
 * Collection d'icônes statiques — cible web.
 *
 * Le TRACÉ de chaque icône est lu dans `../geometry`, que la cible native lit
 * aussi : les deux plateformes ne peuvent plus montrer deux dessins différents
 * pour une même icône.
 *
 * L'annotation `#__PURE__` indique au bundler que l'appel n'a pas d'effet de
 * bord : une icône que personne n'importe est supprimée du bundle, elle et sa
 * géométrie. Sans elle, un appel de fonction au niveau du module est réputé
 * impur, et les 87 icônes voyageraient ensemble.
 *
 * ⚠️  Fichier GÉNÉRÉ — éditer packages/icons/src/geometry.ts, puis « pnpm gen:icons ».
 */
import { fromGeometry } from "../from-geometry";
import {
  PlusIconGeometry,
  MinusIconGeometry,
  XIconGeometry,
  CheckIconGeometry,
  SearchIconGeometry,
  ArrowRightIconGeometry,
  ArrowLeftIconGeometry,
  ArrowUpIconGeometry,
  ArrowDownIconGeometry,
  ChevronDownIconGeometry,
  ChevronUpIconGeometry,
  ChevronRightIconGeometry,
  ChevronLeftIconGeometry,
  RefreshIconGeometry,
  ExternalLinkIconGeometry,
  ShareIconGeometry,
  FilterIconGeometry,
  GridIconGeometry,
  MenuIconGeometry,
  MoreVerticalIconGeometry,
  MoreHorizontalIconGeometry,
  ListIconGeometry,
  SunIconGeometry,
  SunSolidIconGeometry,
  MoonIconGeometry,
  MoonSolidIconGeometry,
  HeartIconGeometry,
  HeartSolidIconGeometry,
  StarIconGeometry,
  StarSolidIconGeometry,
  BookmarkIconGeometry,
  BookmarkSolidIconGeometry,
  BellIconGeometry,
  BellSolidIconGeometry,
  LockIconGeometry,
  LockOpenIconGeometry,
  LockSolidIconGeometry,
  ShieldIconGeometry,
  ShieldSolidIconGeometry,
  FolderIconGeometry,
  FolderSolidIconGeometry,
  SquareIconGeometry,
  CheckSquareIconGeometry,
  CheckSquareSolidIconGeometry,
  CircleIconGeometry,
  CircleDotIconGeometry,
  UserIconGeometry,
  UserSolidIconGeometry,
  UsersIconGeometry,
  UsersSolidIconGeometry,
  CopyIconGeometry,
  FileIconGeometry,
  TrashIconGeometry,
  InboxIconGeometry,
  UploadIconGeometry,
  DownloadIconGeometry,
  SettingsIconGeometry,
  SparklesIconGeometry,
  PlayIconGeometry,
  PauseIconGeometry,
  EyeIconGeometry,
  EyeOffIconGeometry,
  VolumeIconGeometry,
  VolumeMuteIconGeometry,
  ChartIconGeometry,
  CloudIconGeometry,
  ServerIconGeometry,
  DatabaseIconGeometry,
  CpuIconGeometry,
  LayersIconGeometry,
  GlobeIconGeometry,
  MailIconGeometry,
  PhoneIconGeometry,
  MapPinIconGeometry,
  ClockIconGeometry,
  CalendarIconGeometry,
  ZapIconGeometry,
  CodeIconGeometry,
  TerminalIconGeometry,
  InfoIconGeometry,
  InfoSolidIconGeometry,
  AlertTriangleIconGeometry,
  AlertTriangleSolidIconGeometry,
  CheckCircleIconGeometry,
  CheckCircleSolidIconGeometry,
  XCircleIconGeometry,
  XCircleSolidIconGeometry,
} from "../geometry";

/* -------------------------------------------------------------------------- */
/* 1. ACTIONS & NAVIGATION                                                  */
/* -------------------------------------------------------------------------- */

export const PlusIcon = /*#__PURE__*/ fromGeometry(PlusIconGeometry, "PlusIcon");
export const MinusIcon = /*#__PURE__*/ fromGeometry(MinusIconGeometry, "MinusIcon");
export const XIcon = /*#__PURE__*/ fromGeometry(XIconGeometry, "XIcon");
export const CheckIcon = /*#__PURE__*/ fromGeometry(CheckIconGeometry, "CheckIcon");
export const SearchIcon = /*#__PURE__*/ fromGeometry(SearchIconGeometry, "SearchIcon");
export const ArrowRightIcon = /*#__PURE__*/ fromGeometry(ArrowRightIconGeometry, "ArrowRightIcon");
export const ArrowLeftIcon = /*#__PURE__*/ fromGeometry(ArrowLeftIconGeometry, "ArrowLeftIcon");
export const ArrowUpIcon = /*#__PURE__*/ fromGeometry(ArrowUpIconGeometry, "ArrowUpIcon");
export const ArrowDownIcon = /*#__PURE__*/ fromGeometry(ArrowDownIconGeometry, "ArrowDownIcon");
export const ChevronDownIcon = /*#__PURE__*/ fromGeometry(ChevronDownIconGeometry, "ChevronDownIcon");
export const ChevronUpIcon = /*#__PURE__*/ fromGeometry(ChevronUpIconGeometry, "ChevronUpIcon");
export const ChevronRightIcon = /*#__PURE__*/ fromGeometry(ChevronRightIconGeometry, "ChevronRightIcon");
export const ChevronLeftIcon = /*#__PURE__*/ fromGeometry(ChevronLeftIconGeometry, "ChevronLeftIcon");
export const RefreshIcon = /*#__PURE__*/ fromGeometry(RefreshIconGeometry, "RefreshIcon");
export const ExternalLinkIcon = /*#__PURE__*/ fromGeometry(ExternalLinkIconGeometry, "ExternalLinkIcon");
export const ShareIcon = /*#__PURE__*/ fromGeometry(ShareIconGeometry, "ShareIcon");
export const FilterIcon = /*#__PURE__*/ fromGeometry(FilterIconGeometry, "FilterIcon");
export const GridIcon = /*#__PURE__*/ fromGeometry(GridIconGeometry, "GridIcon");
export const MenuIcon = /*#__PURE__*/ fromGeometry(MenuIconGeometry, "MenuIcon");
export const MoreVerticalIcon = /*#__PURE__*/ fromGeometry(MoreVerticalIconGeometry, "MoreVerticalIcon");
export const MoreHorizontalIcon = /*#__PURE__*/ fromGeometry(MoreHorizontalIconGeometry, "MoreHorizontalIcon");
export const ListIcon = /*#__PURE__*/ fromGeometry(ListIconGeometry, "ListIcon");

/* -------------------------------------------------------------------------- */
/* 2. THÈME, FAVORIS & ÉTATS ACTIFS (OUTLINE & SOLID PAIRS)                 */
/* -------------------------------------------------------------------------- */


/* --- Soleil --- */
export const SunIcon = /*#__PURE__*/ fromGeometry(SunIconGeometry, "SunIcon");
export const SunSolidIcon = /*#__PURE__*/ fromGeometry(SunSolidIconGeometry, "SunSolidIcon");

/* --- Lune --- */
export const MoonIcon = /*#__PURE__*/ fromGeometry(MoonIconGeometry, "MoonIcon");
export const MoonSolidIcon = /*#__PURE__*/ fromGeometry(MoonSolidIconGeometry, "MoonSolidIcon");

/* --- Cœur --- */
export const HeartIcon = /*#__PURE__*/ fromGeometry(HeartIconGeometry, "HeartIcon");
export const HeartSolidIcon = /*#__PURE__*/ fromGeometry(HeartSolidIconGeometry, "HeartSolidIcon");

/* --- Étoile --- */
export const StarIcon = /*#__PURE__*/ fromGeometry(StarIconGeometry, "StarIcon");
export const StarSolidIcon = /*#__PURE__*/ fromGeometry(StarSolidIconGeometry, "StarSolidIcon");

/* --- Marque-page --- */
export const BookmarkIcon = /*#__PURE__*/ fromGeometry(BookmarkIconGeometry, "BookmarkIcon");
export const BookmarkSolidIcon = /*#__PURE__*/ fromGeometry(BookmarkSolidIconGeometry, "BookmarkSolidIcon");

/* --- Cloche --- */
export const BellIcon = /*#__PURE__*/ fromGeometry(BellIconGeometry, "BellIcon");
export const BellSolidIcon = /*#__PURE__*/ fromGeometry(BellSolidIconGeometry, "BellSolidIcon");

/* --- Cadenas --- */
export const LockIcon = /*#__PURE__*/ fromGeometry(LockIconGeometry, "LockIcon");
export const LockOpenIcon = /*#__PURE__*/ fromGeometry(LockOpenIconGeometry, "LockOpenIcon");
export const LockSolidIcon = /*#__PURE__*/ fromGeometry(LockSolidIconGeometry, "LockSolidIcon");

/* --- Bouclier --- */
export const ShieldIcon = /*#__PURE__*/ fromGeometry(ShieldIconGeometry, "ShieldIcon");
export const ShieldSolidIcon = /*#__PURE__*/ fromGeometry(ShieldSolidIconGeometry, "ShieldSolidIcon");

/* --- Dossier --- */
export const FolderIcon = /*#__PURE__*/ fromGeometry(FolderIconGeometry, "FolderIcon");
export const FolderSolidIcon = /*#__PURE__*/ fromGeometry(FolderSolidIconGeometry, "FolderSolidIcon");

/* -------------------------------------------------------------------------- */
/* 3. SÉLECTION & CHECKBOX / RADIO / VUES                                   */
/* -------------------------------------------------------------------------- */

export const SquareIcon = /*#__PURE__*/ fromGeometry(SquareIconGeometry, "SquareIcon");
export const CheckSquareIcon = /*#__PURE__*/ fromGeometry(CheckSquareIconGeometry, "CheckSquareIcon");
export const CheckSquareSolidIcon = /*#__PURE__*/ fromGeometry(CheckSquareSolidIconGeometry, "CheckSquareSolidIcon");
export const CircleIcon = /*#__PURE__*/ fromGeometry(CircleIconGeometry, "CircleIcon");
export const CircleDotIcon = /*#__PURE__*/ fromGeometry(CircleDotIconGeometry, "CircleDotIcon");

/* -------------------------------------------------------------------------- */
/* 4. SYSTÈME, TECHNIQUE & MÉDIAS                                           */
/* -------------------------------------------------------------------------- */

export const UserIcon = /*#__PURE__*/ fromGeometry(UserIconGeometry, "UserIcon");
export const UserSolidIcon = /*#__PURE__*/ fromGeometry(UserSolidIconGeometry, "UserSolidIcon");
export const UsersIcon = /*#__PURE__*/ fromGeometry(UsersIconGeometry, "UsersIcon");
export const UsersSolidIcon = /*#__PURE__*/ fromGeometry(UsersSolidIconGeometry, "UsersSolidIcon");
export const CopyIcon = /*#__PURE__*/ fromGeometry(CopyIconGeometry, "CopyIcon");
export const FileIcon = /*#__PURE__*/ fromGeometry(FileIconGeometry, "FileIcon");
export const TrashIcon = /*#__PURE__*/ fromGeometry(TrashIconGeometry, "TrashIcon");
export const InboxIcon = /*#__PURE__*/ fromGeometry(InboxIconGeometry, "InboxIcon");
export const UploadIcon = /*#__PURE__*/ fromGeometry(UploadIconGeometry, "UploadIcon");
export const DownloadIcon = /*#__PURE__*/ fromGeometry(DownloadIconGeometry, "DownloadIcon");
export const SettingsIcon = /*#__PURE__*/ fromGeometry(SettingsIconGeometry, "SettingsIcon");
export const SparklesIcon = /*#__PURE__*/ fromGeometry(SparklesIconGeometry, "SparklesIcon");
export const PlayIcon = /*#__PURE__*/ fromGeometry(PlayIconGeometry, "PlayIcon");
export const PauseIcon = /*#__PURE__*/ fromGeometry(PauseIconGeometry, "PauseIcon");
export const EyeIcon = /*#__PURE__*/ fromGeometry(EyeIconGeometry, "EyeIcon");
export const EyeOffIcon = /*#__PURE__*/ fromGeometry(EyeOffIconGeometry, "EyeOffIcon");
export const VolumeIcon = /*#__PURE__*/ fromGeometry(VolumeIconGeometry, "VolumeIcon");
export const VolumeMuteIcon = /*#__PURE__*/ fromGeometry(VolumeMuteIconGeometry, "VolumeMuteIcon");
export const ChartIcon = /*#__PURE__*/ fromGeometry(ChartIconGeometry, "ChartIcon");
export const CloudIcon = /*#__PURE__*/ fromGeometry(CloudIconGeometry, "CloudIcon");
export const ServerIcon = /*#__PURE__*/ fromGeometry(ServerIconGeometry, "ServerIcon");
export const DatabaseIcon = /*#__PURE__*/ fromGeometry(DatabaseIconGeometry, "DatabaseIcon");
export const CpuIcon = /*#__PURE__*/ fromGeometry(CpuIconGeometry, "CpuIcon");
export const LayersIcon = /*#__PURE__*/ fromGeometry(LayersIconGeometry, "LayersIcon");
export const GlobeIcon = /*#__PURE__*/ fromGeometry(GlobeIconGeometry, "GlobeIcon");
export const MailIcon = /*#__PURE__*/ fromGeometry(MailIconGeometry, "MailIcon");
export const PhoneIcon = /*#__PURE__*/ fromGeometry(PhoneIconGeometry, "PhoneIcon");
export const MapPinIcon = /*#__PURE__*/ fromGeometry(MapPinIconGeometry, "MapPinIcon");
export const ClockIcon = /*#__PURE__*/ fromGeometry(ClockIconGeometry, "ClockIcon");
export const CalendarIcon = /*#__PURE__*/ fromGeometry(CalendarIconGeometry, "CalendarIcon");
export const ZapIcon = /*#__PURE__*/ fromGeometry(ZapIconGeometry, "ZapIcon");
export const CodeIcon = /*#__PURE__*/ fromGeometry(CodeIconGeometry, "CodeIcon");
export const TerminalIcon = /*#__PURE__*/ fromGeometry(TerminalIconGeometry, "TerminalIcon");

/* --- Status & Notifications --- */
export const InfoIcon = /*#__PURE__*/ fromGeometry(InfoIconGeometry, "InfoIcon");
export const InfoSolidIcon = /*#__PURE__*/ fromGeometry(InfoSolidIconGeometry, "InfoSolidIcon");
export const AlertTriangleIcon = /*#__PURE__*/ fromGeometry(AlertTriangleIconGeometry, "AlertTriangleIcon");
export const AlertTriangleSolidIcon = /*#__PURE__*/ fromGeometry(AlertTriangleSolidIconGeometry, "AlertTriangleSolidIcon");
export const CheckCircleIcon = /*#__PURE__*/ fromGeometry(CheckCircleIconGeometry, "CheckCircleIcon");
export const CheckCircleSolidIcon = /*#__PURE__*/ fromGeometry(CheckCircleSolidIconGeometry, "CheckCircleSolidIcon");
export const XCircleIcon = /*#__PURE__*/ fromGeometry(XCircleIconGeometry, "XCircleIcon");
export const XCircleSolidIcon = /*#__PURE__*/ fromGeometry(XCircleSolidIconGeometry, "XCircleSolidIcon");
